import redact from 'redact-object';
import { reportToSentry } from './sentry';

export const redactUrlBeforeSend = (url: string): string => {
  try {
    const redactedUrl = new URL(url);

    const pathsWithTokenRegex =
      /(?<path>reset-password|confirm-email)\/(?<token>[^&]*)/i;

    if (pathsWithTokenRegex.test(redactedUrl.pathname)) {
      redactedUrl.pathname = redactedUrl.pathname.replace(
        pathsWithTokenRegex,
        '$<path>/REDACTED_TOKEN',
      );
    }

    const searchParams = Object.fromEntries(redactedUrl.searchParams.entries());

    const redactedParams = redact(
      searchParams,
      [
        'email',
        'first_name',
        'last_name',
        'token',
        'invitation',
        'api_key',
        'apikey',
      ],
      'REDACTED',
    );

    redactedUrl.search = new URLSearchParams(redactedParams).toString();

    return redactedUrl.toString();
  } catch {
    reportToSentry(`Invalid URL sent to analytics service: ${url}`);
    return url;
  }
};
